import * as React from "react";
import {Box} from "@mui/material";
import AgingTierScale from "./list_current_accounts/AgingTierScale";

export default function AgingBadge({tierCode, label, theme}) {
    const color = AgingTierScale.default().colorOf(tierCode, theme);
    return (
        <Box sx={{
            display: 'inline-flex', alignItems: 'center', gap: '5px',
            fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '100px',
            backgroundColor: `${color}22`, color,
        }}>
            <Box sx={{width: 6, height: 6, borderRadius: '50%', backgroundColor: 'currentColor'}}/>
            {label}
        </Box>
    );
}
